import type { PageResponseDto } from '@/lib/api/event/types';
import { createHttpClient } from '@/lib/api/httpClient';
import { resolveStrapiBaseUrl } from './utils';

const BASE_URL = resolveStrapiBaseUrl();

const http = createHttpClient({ baseUrl: BASE_URL });

interface NewsSearchItemDto {
  i: string;
  t: string;
  s: string;
  pb: string;
  ct?: string;
}

export interface NewsSearchItem {
  id: string;
  title: string;
  slug: string;
  publishedAt: string;
  categorySlug?: string;
}

export interface SearchNewsProxyParams {
  q?: string;
  page?: number;
  size?: number;
  locale?: string;
}

export interface SearchNewsProxyResult {
  news: NewsSearchItem[];
  total: number;
  page: number;
  size: number;
  totalPages: number;
}

export async function searchNewsProxy(
  params: SearchNewsProxyParams,
): Promise<SearchNewsProxyResult> {
  const dto = await http.get<PageResponseDto<NewsSearchItemDto>>('/api/news/search', {
    query: {
      ...(params.q ? { q: params.q } : {}),
      ...(params.page !== undefined ? { page: params.page } : {}),
      ...(params.size !== undefined ? { size: params.size } : {}),
      ...(params.locale ? { locale: params.locale } : {}),
    },
  });

  return {
    news: (dto.content ?? []).map((item) => ({
      id: item.i,
      title: item.t,
      slug: item.s,
      publishedAt: item.pb,
      categorySlug: item.ct,
    })),
    total: dto.totalElements ?? 0,
    page: (dto.number ?? 0) + 1,
    size: dto.size ?? 0,
    totalPages: dto.totalPages ?? 0,
  };
}
